import type { Product } from "@jti/magento";

export const getFilteredSubscriptionItems = (items: Product[] | undefined): Product[] => {
  const subscriptionItems: Product[] = [];

  items?.forEach((item: Product) => {
    if (item.subscription === 1) {
      subscriptionItems.push(item);
    }
  });

  return subscriptionItems;
};
